import React from 'react';
import PropTypes from 'prop-types';
import { PageSection } from 'reaxl';
import AdsEnabled from './AdsEnabled';
import AtcAdSlot from '@/utilities/AtcAdSlot';

const adSlot = (data) => {
    const {
        slotId,
        showPlaceholder,
        adSizes,
        pos,
        ...rest
    } = data;

    return (
        <AdsEnabled>
            <AtcAdSlot
                slotId={slotId}
                lazyLoading
                showPlaceholder={showPlaceholder}
                size={adSizes}
                targeting={{
                    pos,
                }}
                {...rest}
            />
        </AdsEnabled>
    );
};

const adSlotFullWidth = (data) => (
    <PageSection
        data-cmp="adSlotSection"
        uiContext="section-2"
        alignment="center"
        offset={1}
    >
        { adSlot(data) }
    </PageSection>
);

const AdsContainer = React.memo(({
    slotId,
    pos,
    adSizes,
    showAd = true,
    showPlaceholder,
    uiContext,
    adsLazyLoadingOffset,
}) => {

    let renderAdSlot = null;

    if (showAd && adSizes?.length > 0) {

        const AdSlotData = {
            slotId,
            pos,
            adSizes,
            showPlaceholder,
        };

        if (adsLazyLoadingOffset) {
            AdSlotData.lazyLoadingTopOffset = adsLazyLoadingOffset;
            AdSlotData.lazyLoadingBottomOffset = adsLazyLoadingOffset;
        }

        switch (uiContext) {
            case 'fullwidth': {
                renderAdSlot = adSlotFullWidth(AdSlotData);
                break;
            }
            default: {
                renderAdSlot = adSlot(AdSlotData);
            }
        }
    }

    return renderAdSlot;
});

AdsContainer.propTypes = {
    slotId: PropTypes.string,
    pos: PropTypes.string,
    adSizes: PropTypes.array,
    showAd: PropTypes.bool,
    uiContext: PropTypes.string,
    adsLazyLoadingOffset: PropTypes.number,
};

export default AdsContainer;
